export const ISSUE_TYPES_FIELD_ISSUE_TYPE = 'issueType';
export const ISSUE_TYPES_FIELD_ISSUE_SUBTYPE = 'issueSubtype';
export const ISSUE_TYPES_FIELD_ISSUE_TYPE_MANAGER = 'managers';
export const ISSUE_TYPES_FIELD_CREATED = 'createdAt';
export const ISSUE_TYPES_FIELD_CREATED_BY = 'createdBy';
